<template>
    <div class="modal-mask">
            <div class="modal-wrapper">
                <div class="modal_size sm_size">
                    <a href="javascript:" class="ui_close" type="button" @click="$emit('close')"><span class="sr_only">popup close</span></a>
                    <dl class="modal_content"><!-- 200413수정 noline 클래스 삭제 -->
                        <dt class="ellipsis">
                            <slot name="header">
                                {{ $t('TITLE.POPUP.SERVICE.SCRIPT.DELETE') }}
                            </slot>
                        </dt>
                        <dd>
                            <div class="opinion_wrap auto_height">
                                <ul class="opinion_list">
                                    <li data-val="A"
                                        :data-txt="$t('FIELD.POPUP.SERVICE.SCRIPT.REASON.DUPLICATED')"
                                        :class="selVal === 'A' ? 'active' : ''"
                                        @click="selDelReason($event)"
                                    >
                                        {{ $t('FIELD.POPUP.SERVICE.SCRIPT.REASON.DUPLICATED') }}
                                    </li>
                                    <li data-val="B"
                                        :data-txt="$t('FIELD.POPUP.SERVICE.SCRIPT.REASON.UNRELEASED')"
                                        :class="selVal === 'B' ? 'active' : ''"
                                        @click="selDelReason($event)"
                                    >
                                        {{ $t('FIELD.POPUP.SERVICE.SCRIPT.REASON.UNRELEASED') }}
                                    </li>
                                    <li data-val="C"
                                        :data-txt="$t('FIELD.POPUP.SERVICE.SCRIPT.REASON.PROD.ACC')"
                                        :class="selVal === 'C' ? 'active' : ''"
                                        @click="selDelReason($event)"
                                    >
                                        {{ $t('FIELD.POPUP.SERVICE.SCRIPT.REASON.PROD.ACC') }}
                                    </li>
                                    <li data-val="D"
                                        :data-txt="$t('FIELD.POPUP.SERVICE.SCRIPT.REASON.OTHERS')"
                                        :class="selVal === 'D' ? 'active' : ''"
                                        @click="selDelReason($event)"
                                    >
                                        {{ $t('FIELD.POPUP.SERVICE.SCRIPT.REASON.OTHERS') }}
                                    </li>
                                </ul>
                            </div>
                            <div class="btn_modal_wrap topLine">
                                <div class="btn_right">
                                    <a href="javascript:" class="btn_white" @click="$emit('close')">{{ $t('BUTTON.GLOBAL.CANCEL') }}</a>
                                    <a href="javascript:" class="btn_blue" @click="btnDelete">{{ $t('BUTTON.GLOBAL.DELETE') }}</a>
                                </div>
                            </div>
                        </dd>
                    </dl>
                </div>
            </div>
        </div>
</template>
<script>
import Vue                                  from 'vue';
import axios                                from 'axios';
import qs                                   from 'query-string';
import { mapGetters, mapActions }           from 'vuex';
import _                                    from 'lodash';
import $                                    from 'jquery';
import api                                  from '@/service';
import store                                from '@/vuex/store';
import { SDLUtil, MenuUtil, StringUtil }    from '@/utils';
import { EventBus }                         from '@/utils/EventBus';

export default {
    name: 'ServiceScriptDeletePopup',
    props: {
        selectedList:   { },
        showType:       { required: true },
        delMode:        { default: 'M' },
        rtnFunc:        { type: Function }
    },
    data() {
        return {
            selVal: '',
            selParams: {},
        }
    },
    computed: {
        ...mapGetters({
            userRoles: 'getRoles',
            userCorpCd: 'getCorpCd',
            params: 'getParams',
            locale: 'getLocale',
            menus: 'getMenus',
        }),
    },
    methods: {
        selDelReason(e) {
            let target = e.target;
            let value = target.getAttribute('data-val'),
                text = target.getAttribute('data-txt');

            if(this.selVal !== value) {
                this.selVal = value;
                this.selParams = {
                    reasonCd: value,
                    reasonTxt: text
                };
            };
        },
        btnDelete() {
            if(SDLUtil.isNull(this.selParams.reasonCd)) {
                SDLUtil.alert('MESSAGE.DATA.CHECKDELETE');

            } else {
                // Vue.$log.info('ServiceScriptDeletePopup.vue delete event.', this.selParams, this.selectedList);
                let single = `${SDLUtil.API_URL}/basis/myKnowledge/serviceScript/delete.skp`,
                    multi  = `${SDLUtil.API_URL}/basis/myKnowledge/serviceScript/deleteList.skp`;
                axios.post(
                    this.delMode === 'S' ? single : multi,
                    qs.stringify({
                        del_reason: this.selParams.reasonTxt || '',
                        SHOW_TYPE: this.showType,
                        KNOWLEDGE_ID: this.selectedList.map(s => { return s.KNOWLEDGE_ID; }).join('^'),
                        SERVICE_SCRIPT_ID: this.selectedList.map(s => { return s.SERVICE_SCRIPT_ID; }).join('^')
                    }),
                    { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
                )
                .then(res => {
                    let that = this,
                        data = res.data;

                    if(data.msg) {
                        SDLUtil.alert({
                            title: 'MESSAGE.SUCCESS.DELETED',
                            msg: _.replace(data.msg, /(\r?\\n)/g, '<br/>'),
                            okLabel: 'BUTTON.GLOBAL.OK',
                            onOkEvt: () => {
                                if(typeof that.rtnFunc === 'function') {
                                    that.rtnFunc();
                                };

                                that.$emit('close');
                            }
                        });
                    }

                })
                .catch(err => {
                    SDLUtil.errorAlert(err);
                    SDLUtil.showLoadingBar(false);
                });

            }
        }
    },
    created() {
        Vue.$log.info('ServiceScriptDeletePopup.vue created.', this.selectedList);
    },
    mounted() {

    },
    beforeDestroy() {

    }
};
</script>


// WEBPACK FOOTER //
// src/skpComponents/view/basis/myKnowledge/serviceScript/popup/ServiceScriptDeletePopup.vue